import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { BroadcastService, messageType } from '@core/services';

import { endpoints } from '@environment';

import { AuthService } from '@auth/services';
import { AuthActions } from '@auth/state';

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {
  constructor(private store: Store, private authService: AuthService, private router: Router, private broadcastService: BroadcastService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // skip error reports / client logs
    if (req.urlWithParams.match('.*/log/(error|client).*')) {
      return next.handle(req);
    }

    // skip specific auth endpoints as they handle errors separately
    if (req.urlWithParams.match('.*/auth/(login|logout|ping|change-facility|change-customer).*')) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (req.url === endpoints.auth.login) {
          return throwError(() => error);
        }

        if (error.status === 401) {
          this.broadcastService.send({ type: messageType.logout });
          this.store.dispatch(AuthActions.SetAuthenticated({ authenticated: false }));
          void this.router.navigate(['login']);
          return [];
        }

        return throwError(() => error);
      }),

      tap(() => {
        this.authService.updateLastActivity();
      })
    );
  }
}
